import React, { createContext, useContext } from 'react';

export interface CompanyConfig {
  isEnterprise: boolean;
  companyName: string;
  contactEmail: string;
  colorPrimary: string;
  colorPrimaryLighter: string;
  privacyUrl: string;
  termsUrl: string;
  footerText: string;
  domainUrl: string;
  donationUrl?: string;
  volunteerUrl?: string;
  logoUrl?: string;
}

interface CompanyContextType {
  companyConfig: CompanyConfig;
}

export const defaultCompanyConfig: CompanyConfig = {
  isEnterprise: false,
  companyName: 'Eternal Applications',
  contactEmail: 'info@eternalapplications.com',
  colorPrimary: '#5449dc',
  colorPrimaryLighter: '#eeedfb',
  domainUrl: 'https://www.eternalapplications.com',
  privacyUrl: 'https://www.eternalapplications.com/privacy',
  termsUrl: 'https://www.eternalapplications.com/terms',
  footerText: '© Eternal Applications, Inc. All rights reserved.'
};

const CompanyContext = createContext<CompanyContextType>({
  companyConfig: defaultCompanyConfig
});

export const useCompanyContext = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompanyContext must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider: React.FC<{
  children: React.ReactNode;
  companyConfig: CompanyConfig;
}> = ({ children, companyConfig }) => {
  return <CompanyContext.Provider value={{ companyConfig }}>{children}</CompanyContext.Provider>;
};
